import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconCottage = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconCottage",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M160-200v-295l-40 31q-14 10-30 8t-26-16-8-30 15-26l89-68v-84q0-17 12-28t28-12 29 12 11 28v23l191-146q11-8 24-12t25-4 26 4 23 12l360 275q13 10 15 26t-8 30q-10 13-26 15t-29-8l-41-30v295q0 33-23 57t-57 23H540q-8 0-14-6t-6-14v-180q0-17-11-28t-29-12-28 12-12 28v180q0 8-6 14t-14 6H240q-33 0-56-23t-24-57m52-560q-23 0-35-19t-2-39q17-29 45-45t60-17q11 0 21-5t15-16q5-9 14-14t19-5q23 0 35 19t1 39q-17 29-44 46t-61 16q-11 0-21 5t-15 16q-5 9-13 14t-19 5"
  })
}));